module.exports = __webpack_public_path__ + "images/5cfb52d1a3aa30f2b2a451e957472821-GLP FILMS.png";